export enum DayPairKey {
  "Monday & Tuesday" = "Monday & Tuesday",
  "Friday & Saturday" = "Friday & Saturday",
  "Saturday & Sunday" = "Saturday & Sunday",
}

export type DayPair = [string, string];

export type cardData = {
  fDate: string;
  fStartTime: string;
  fEndTime: string;
  sDate: string;
  sStartTime: string;
  sEndTime: string;
  tDate?: string;
  tStartTime?: string;
  tEndTime?: string;
  price: string;
  availablePlaces: string;
  extraDescription?: string;
};

export const getDayOfWeek = (dateString: string) => {
  const date = new Date(dateString.split(".").reverse().join("-"));
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return daysOfWeek[date.getDay()];
};

export function filterData(
  selectedCombinations: Set<string>[],
  data: cardData[]
) {
  // Ensure selectedCombinations is not empty
  if (!selectedCombinations || selectedCombinations.length === 0) {
    return data;
  }

  if (!Array.isArray(selectedCombinations)) {
    throw new Error("selectedCombinations must be an array of Sets");
  }

  return data.filter((item) => {
    const fDay = getDayOfWeek(item.fDate);
    const sDay = getDayOfWeek(item.sDate);
    const tDay = item?.tDate && getDayOfWeek(item.tDate);

    return selectedCombinations.some((combination) => {
      // We are comparing the two days in the combination set
      const sortedCombination = Array.from(combination).sort();

      // Check if the fDay and sDay are part of the sorted combination set
      return tDay
        ? (sortedCombination[0] === fDay ||
            sortedCombination[0] === sDay ||
            sortedCombination[0] === tDay) &&
            (sortedCombination[1] === fDay ||
              sortedCombination[1] === sDay ||
              sortedCombination[1] === tDay) &&
            (sortedCombination[2] === fDay ||
              sortedCombination[2] === sDay ||
              sortedCombination[2] === tDay)
        : (sortedCombination[0] === fDay || sortedCombination[1] === fDay) &&
            (sortedCombination[0] === sDay || sortedCombination[1] === sDay);
    });
  });
}
